import React, { useState } from 'react';
import { auth } from '../../firebase/firebase.utils';
import history from '../../history';


import FormInput from '../../components/form-input/form-input.component';
import CustomButton from '../../components/custom-button/custom-button.component';
import Button from '@material-ui/core/Button';

import { MacroContainer, ResetPasswordContainer, LogoContainer, TitleContainer} from './reset-password-page.styles';


const ResetPasswordPage = () => {

    const [email, setEmail] = useState("");



    const onChangeHandler = event => {
        const { name, value } = event.target;
        if (name === "userEmail") {
            setEmail(value);
        }
    };

    const sendResetEmail = event => {
        event.preventDefault();
        auth
        .sendPasswordResetEmail(email)
        .then(() => {
           alert("Check your email for a reset link.")
        })
        .catch(() => {
          alert("Error resetting password");
        });
    };
        
    return (
        <MacroContainer>
        <ResetPasswordContainer>
            <LogoContainer>
                    <img id="logo" alt="logo"  src={require("../../assets/mrsLogo.png")} height="auto" width="100%" />
            </LogoContainer>
            <TitleContainer>Reset Your Password</TitleContainer>
            <span>Enter your email address and submit a request.</span>


            <form onSubmit={sendResetEmail}>
                <FormInput 
                    name="userEmail" 
                    type="email" 
                    value={email} 
                    handleChange={onChangeHandler}
                    label="Email"
                    required 
                />

                <CustomButton type="submit">SUBMIT RESET REQUEST</CustomButton>

            </form> 
            <Button color="primary" style={{fontSize: "18px", marginTop: "20px", width: "300px", textAlign: "left"}} 
                onClick={() => history.push('/signin')}>RETURN TO SIGN-IN PAGE</Button>
                

        </ResetPasswordContainer>
        </MacroContainer>
    );
};

export default ResetPasswordPage;

